import React, {useState} from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {PersonaModal} from "../../../../../components/modals/PersonaModal";
import {UserInputSettings} from "./components/user-input-settings";
import {fieldSx} from "../editMenuStyles";
import {SectionHeader} from "../components/EditMenuSection";

export const QASettings = ({node, setNode, onUpdate, onChangeData}) => {
    const [expandPersona, setExpandPersona] = useState(false);
    const [expandParaphrazerPersona, setExpandParaphrazerPersona] = useState(false);

    const {primary, secondary} = menuItemsInfo.knowledge_base;

    return (
        <>
            <PersonaModal
                handleClose={() => setExpandPersona(false)}
                open={expandPersona}
                onSuccess={(content) => onChangeData("persona", content)}
                text={node?.data?.persona}
            />
            <PersonaModal
                handleClose={() => setExpandParaphrazerPersona(false)}
                open={expandParaphrazerPersona}
                onSuccess={(content) => onChangeData("persona_paraphrazer", content)}
                text={node?.data?.persona_paraphrazer}
            />

            <SectionHeader title={primary} description={secondary}/>

            <TextField
                label="QA Api"
                size="small"
                value={node?.data?.qa_api}
                InputLabelProps={{shrink: true}}
                sx={fieldSx}
                onBlur={() => onUpdate(node)}
                onChange={(e) => setNode(prev => ({...prev, data: {...prev.data, qa_api: e.target.value}}))}
            />
            <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel id="qa-method-label">QA Method</InputLabel>
                <Select
                    labelId="qa-method-label"
                    value={node?.data?.qa_method || null}
                    label="QA Method"
                    onBlur={() => onUpdate(node)}
                    onChange={(e) => setNode(prev => ({...prev, data: {...prev.data, qa_method: e.target.value}}))}
                >
                    <MenuItem value={null}><em>None</em></MenuItem>
                    <MenuItem value="GET">GET</MenuItem>
                    <MenuItem value="POST">POST</MenuItem>
                    <MenuItem value="PUT">PUT</MenuItem>
                    <MenuItem value="PATCH">PATCH</MenuItem>
                </Select>
            </FormControl>
            <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData}/>
        </>
    );
};
